import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { BetaFeatureRequest, BetaFeatureResponse } from '@/Interfaces/I_betaFeature';
import { UserGroupResponse, UserResponse } from '@/Interfaces/I_userGroup';

const BetaFeaturesSlice = createSlice({
  name: 'betaFeatures',
  initialState: {
    value: {
      betaFeatures: {
        data: [] as BetaFeatureResponse[],
        loading: false,
        error: '',
        searched: {
          loadingUsers: false,
          users: [] as UserResponse[],
          loadingUserGroups: false,
          userGroups: [] as UserGroupResponse[],
        },
      },
    },
  },
  reducers: {
    getBetaFeaturesData: (state) => {
      const assignState = state;
      assignState.value.betaFeatures.loading = true;
    },
    setBetaFeatures: (state, action: PayloadAction<BetaFeatureResponse[]>) => {
      const assignState = state;
      assignState.value.betaFeatures.data = action.payload;
      assignState.value.betaFeatures.loading = false;
      assignState.value.betaFeatures.error = '';
    },
    setBetaFeaturesError: (state, action: PayloadAction<string>) => {
      const assignState = state;
      assignState.value.betaFeatures.error = action.payload;
      assignState.value.betaFeatures.loading = false;
    },
    postCreateBetaFeatue: (state, _action: PayloadAction<BetaFeatureRequest>) => {
      const assignState = state;
      assignState.value.betaFeatures.loading = true;
    },
    putUpdateBetaFeatue: (
      state,
      _action: PayloadAction<{ id: number; data: BetaFeatureRequest }>,
    ) => {
      const assignState = state;
      assignState.value.betaFeatures.loading = true;
    },
    deleteBetaFeature: (state, _action: PayloadAction<number>) => {
      const assignState = state;
      assignState.value.betaFeatures.loading = true;
    },
    betaFeatureSearchUsers: (state, _action: PayloadAction<string>) => {
      const assignState = state;
      assignState.value.betaFeatures.searched.users = [];
      assignState.value.betaFeatures.searched.loadingUsers = true;
    },
    setBetaFeatureSearchedUsers: (state, action: PayloadAction<UserResponse[]>) => {
      const assignState = state;
      assignState.value.betaFeatures.searched.users = action.payload;
      assignState.value.betaFeatures.searched.loadingUsers = false;
    },
    betaFeatureSearchUserGroups: (state, _action: PayloadAction<string>) => {
      const assignState = state;
      assignState.value.betaFeatures.searched.userGroups = [];
      assignState.value.betaFeatures.searched.loadingUserGroups = true;
    },
    setBetaFeatureSearchedUserGroups: (state, action: PayloadAction<UserGroupResponse[]>) => {
      const assignState = state;
      assignState.value.betaFeatures.searched.userGroups = action.payload;
      assignState.value.betaFeatures.searched.loadingUserGroups = false;
    },
  },
});

export const {
  getBetaFeaturesData,
  setBetaFeatures,
  setBetaFeaturesError,
  postCreateBetaFeatue,
  putUpdateBetaFeatue,
  deleteBetaFeature,
  betaFeatureSearchUsers,
  betaFeatureSearchUserGroups,
  setBetaFeatureSearchedUsers,
  setBetaFeatureSearchedUserGroups,
} = BetaFeaturesSlice.actions;

export default BetaFeaturesSlice.reducer;
